import classnames from 'classnames';
import videojs from 'video.js';
import { VideoJsPlayer } from 'video.js';

const Component = videojs.getComponent('Component');

type ComponentOptions = videojs.ComponentOptions & {
  title: string;
  description: string;
};

interface FloatingInfo {
  options_: ComponentOptions;
}

class FloatingInfo extends Component {
  constructor(
    player: VideoJsPlayer,
    options?: ComponentOptions,
    ready?: videojs.Component.ReadyCallback
  ) {
    super(player, options, ready);
    this.updateDomContent({
      title: this.options_.title,
      description: this.options_.description,
    });
  }

  buildCSSClass() {
    return classnames(super.buildCSSClass(), 'vjs-floating-info');
  }

  createEl(tag = 'div', props = {}, attributes = {}) {
    props = {
      ...props,
      className: this.buildCSSClass(),
    };

    return videojs.dom.createEl(tag, props, attributes);
  }

  updateDomContent(payload?: { title?: string; description?: string }) {
    videojs.dom.emptyEl(this.el());

    const titleEl = videojs.dom.createEl(
      'div',
      {
        className: 'vjs-floating-info-title',
      },
      {
        ...(payload?.title && { title: payload.title }),
      }
    );

    videojs.dom.textContent(titleEl, payload?.title || '');

    const descriptionEl = videojs.dom.createEl(
      'div',
      {
        className: 'vjs-floating-info-description',
      },
      {
        ...(payload?.description && { title: payload.description }),
      }
    );

    videojs.dom.textContent(descriptionEl, payload?.description || '');

    this.el().appendChild(titleEl);
    this.el().appendChild(descriptionEl);
  }
}

videojs.registerComponent('FloatingInfo', FloatingInfo);

export default FloatingInfo;
